document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var control = event.target.closest('[data-scroll-control]');
  if (!control) return;

  var targetId = control.getAttribute('data-scroll-control');
  var target = document.getElementById(targetId);
  if (!target) return;

  var direction = control.getAttribute('data-direction') === 'prev' ? -1 : 1;
  var distance = target.clientWidth * 0.85 * direction;
  target.scrollBy({ left: distance, behavior: 'smooth' });
});

document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-ht-tab]');
  if (!tab) return;

  var root = tab.closest('[data-ht-tabs]');
  if (!root) return;

  var panelId = tab.getAttribute('data-ht-tab');
  var tabs = root.querySelectorAll('[data-ht-tab]');
  var panels = root.querySelectorAll('[data-ht-tab-panel]');

  tabs.forEach(function (item) {
    var isActive = item === tab;
    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  panels.forEach(function (panel) {
    panel.hidden = panel.id !== panelId;
  });
});
